module.exports = __webpack_public_path__ + "static/media/LK_White_Configurator.6d515ab1.svg";